/* eslint-disable max-lines-per-function */
import "./Section.scss";
import { cn } from "tailwind-variants";

export default function Section({ children, ...restProps }) {
  return (
    <div {...restProps} className={cn("scope-07d524f7", restProps.className, "section")}>
      {children}
    </div>
  );
}
